import React, { Component } from 'react';
import { InstantSearch, Configure } from 'react-instantsearch-dom';
import algoliasearch from 'algoliasearch/lite';
import { connectAutoComplete } from 'react-instantsearch-core';
import { ReactSVG } from 'react-svg';
import SearchBarStyles from './SearchBarStyles';
import sanitizeHtml from 'sanitize-html';
import slugify from "slugify";

const sanitizeSettings = {
  allowedTags: ['b'],
};

const toggleSearchBar = (active) => {
  if (active) {
    document.getElementById('support-search-bar').classList.add('active')
    document.querySelector("#support-search-bar input").focus()
  } else {
    document.getElementById('support-search-bar').classList.remove('active')
  }
}

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      toggleSearchBar(false)
    }
  }

  render() {
    const searchClient = algoliasearch(
      'Q5CDZESHEL',
      '412235a8751a71e3ac29620180c2866b'
    );

    return <SearchBarStyles ref={this.wrapperRef} id="support-search-bar">
      <InstantSearch
        indexName="stage_posts_page"
        onSearchStateChange={(searchState) => console.log(searchState)}
        searchClient={searchClient}
        disableExactOnAttributes={['faq_page_title', 'sections_content']}
      >
        <CustomAutocomplete />
        <Configure
          hitsPerPage={40}
        />
      </InstantSearch>
    </SearchBarStyles>
  };
};

const HitResult = ({ hit, query }) => {
  let highlighthedTitle = hit.title
  let highlightedSummary = hit.short_answer ? hit.short_answer : ''
  if (query.length) {
    const queryCap = query.charAt(0).toUpperCase() + query.slice(1)
    const queryLow = query.toLowerCase()
    let reCap = new RegExp(queryCap, "g"); // search for all instances
    let reLow = new RegExp(queryLow, "g"); // search for all instances
    highlighthedTitle = highlighthedTitle.replace(reLow, `<b>${queryLow}</b>`);
    highlightedSummary = highlightedSummary.replace(reLow, `<b>${queryLow}</b>`);
    highlighthedTitle = highlighthedTitle.replace(reCap, `<b>${queryCap}</b>`);
    highlightedSummary = highlightedSummary.replace(reCap, `<b>${queryCap}</b>`);
  }
  return (
    <a className='hit-item' href={hit.link}>
      <ReactSVG src={hit.icon} className="icon" />
      <span
        className='hit-title'
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(highlighthedTitle, sanitizeSettings)
        }}
      />
      {hit.short_answer && <span
        className='hit-short_answer'
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(highlightedSummary, sanitizeSettings)
        }}
      />
      }
    </a>
  )
}

//Class for rendering the hits for the autocomplete
const Autocomplete = ({ hits, currentRefinement, refine }) => {
  const groupedHits = groupResults(hits, currentRefinement)
  return (
    <div className='autocomplete-input'>
      <ReactSVG className='search-icon' src="/icons/support-search.svg" />
      <ReactSVG className='back-icon' src="/icons/support-back-arrow.svg" onClick={()=>toggleSearchBar(false)}/>
      <input
        type="search"
        placeholder='Search Support'
        value={currentRefinement}
        onChange={event => refine(event.currentTarget.value)}
        onClick={() => toggleSearchBar(true)}
      />
      {currentRefinement.length > 0 &&
        <div className='results'>
          {
            groupedHits.length ? groupedHits.map((group) => {
              return (
                <div className='group'>
                  <div className='group-title'>{group[0]}</div>
                  {
                    group[1].map((hit) => {
                      return (
                        <HitResult hit={hit} query={currentRefinement} />
                      )
                    })
                  }
                </div>
              )
            })
              : <span className='no-reults'>No results found</span>
          }
        </div>
      }
    </div>)
};

const CustomAutocomplete = connectAutoComplete(Autocomplete);

const includesCaseSensitive = (word, match) => {
  return word.toLowerCase().includes(match.toLowerCase())
}

const groupResults = (hits, query) => {
  const result = []
  hits.forEach(hit => {
    let category = 'General';
    if (hit.faq_page_title) {
      const sections_content = JSON.parse(hit.sections_content)
      sections_content.sections.forEach(section => {
        if (includesCaseSensitive(section.title,query) || includesCaseSensitive(section.short_answer,query) || includesCaseSensitive(section.keywords,query)) {
          category = section.is_popular ? 'Popular Pages' : hit.faq_page_title;
          const newHit = {
            title: section.title,
            short_answer: section.short_answer,
            category: category,
            link: hit.relative_permalink + "#" + slugify(section.title, { lower: true }),
            icon: section.is_popular ? '/icons/support-page.svg' : '/icons/support-arrow.svg'
          }
          result.push(newHit)
        }
      });
    } else {
      const title = hit.algolia_result_title ? hit.algolia_result_title : hit.post_title
      if (includesCaseSensitive(title,query)) {
        category = hit.popular_pages ? 'Popular Pages' : 'Other Pages';
        const newHit = {
          title: title,
          short_answer: false,
          category: category,
          link: hit.relative_permalink,
          icon: '/icons/support-page.svg'
        }
        result.push(newHit)
      }
    }
  });

  var groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };
  const groupedHits = groupBy(result, 'category');
  return Object.entries(groupedHits)
}

export default SearchBar;